import React from 'react';
import type { ActivityEntry } from 'shared/src/api/activity-feed-api-types';
import { ActivityCardShell } from './ActivityCardShell';

type CreativeCardProps = {
  entry: ActivityEntry;
  showCampaignName: boolean;
};

export function CreativeCard({ entry, showCampaignName }: CreativeCardProps) {
  const statusStyle = getStatusStyle(entry.contentStatus);

  return (
    <ActivityCardShell entry={entry} showCampaignName={showCampaignName}>
      {entry.contentStatus ? (
        <span
          className={`inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ${statusStyle.classes}`}>
          {statusStyle.dotClass ? (
            <span className={`inline-block size-1.5 rounded-full ${statusStyle.dotClass}`} />
          ) : null}
          {entry.contentStatus}
        </span>
      ) : null}

      {entry.contentBody ? <div className="text-sm text-gray-700">{entry.contentBody}</div> : null}
    </ActivityCardShell>
  );
}

/* ---------------------------------------------------------------------------
 * Private helpers
 * --------------------------------------------------------------------------- */

type StatusStyle = {
  classes: string;
  dotClass: string | null;
};

function getStatusStyle(status: string | null): StatusStyle {
  switch (status) {
    case 'Archived':
      return { classes: 'bg-gray-200 text-gray-600', dotClass: 'bg-gray-400' };
    case 'Complete':
      return { classes: 'bg-lime-200 text-lime-800', dotClass: 'bg-lime-500' };
    case 'Not Started':
      return { classes: 'bg-gray-200 text-gray-600', dotClass: 'bg-gray-400' };
    case 'Creative Review':
      return { classes: 'bg-amber-200 text-amber-800', dotClass: 'bg-amber-500' };
    case 'In Progress':
      return { classes: 'bg-blue-200 text-blue-800', dotClass: 'bg-blue-500' };
    case 'On Hold':
      return { classes: 'bg-amber-200 text-amber-800', dotClass: 'bg-amber-500' };
    default:
      return { classes: 'bg-gray-200 text-gray-600', dotClass: null };
  }
}
